export enum AllocationViewFilterName {
  NoDock = 'noDock',
  WithoutTruckPlate = 'withoutTruckPlate',
  Type = 'type',
  TimeFrame = 'timeFrame',
  CarrierId = 'carrierId',
  CarrierNumber = 'carrierNumber',
  Party = 'party',
  TruckPlate = 'truckPlate',
  CompartmentDockStructure = 'compartmentDockStructure',
  LoadNumbers = 'loadNumbers',
  TransportOrderNumbers = 'transportOrderNumbers',
  DocumentNumbers = 'documentNumbers',
  Uli = 'uli',
  UliOrigin = 'uliOrigin',
  UliStatuses = 'uliStatuses',
  TruckStatuses = 'truckStatuses',
  SlotId = 'slotId',
  RegistrationId = 'registrationId',
  ParkingSpaceId = 'parkingSpaceId',
}

export enum AllocationViewListRangeDate {
  TimeFrame = 'timeFrame',
}

export enum AllocationViewLabelBasedFilter {
  Attention = 'attention',
  NoDock = 'noDock',
  WithoutTruckPlate = 'withoutTruckPlate',
}

export enum AllocationViewCollectionBasedFilter {
  SlotId = 'slotId',
  RegistrationId = 'registrationId',
}
